var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-mini"},[(_vm.data == undefined || _vm.data == null)?_c('p',[_vm._v(_vm._s(_vm.$t('components.userMini.userNotFound')))]):_vm._e(),_vm._v(" "),(_vm.data != undefined && _vm.data != null)?_c('p',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.data.firstName)+" "+_vm._s(_vm.data.lastName))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ba30d1a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserMini.vue
// module id = null
// module chunks = 